import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { LoggerService } from '../../logging/logger.service';
import { catchError, from, map, mergeMap, Observable, of, throwError } from "rxjs";
import { fetchAuthSession, AuthSession, JWT } from 'aws-amplify/auth';

const getToken = (logger: LoggerService): Observable<JWT | undefined | null> => {
  return from(fetchAuthSession()).pipe(
    map((session: AuthSession) => {
      return session.tokens?.idToken;
    }),
    catchError((error) => {
      logger.error('AuthInterceptor', 'Authentication session retrieval failed', error);
      return of(null);
    }),
  );
};

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly logger = inject(LoggerService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.logger.debug('AuthInterceptor', 'Processing HTTP request', { method: req.method });
    return getToken(this.logger).pipe(
      mergeMap((token) => {
        if (token) {
          this.logger.debug('AuthInterceptor', 'Attaching authorization header');
          const cloned = req.clone({
            headers: req.headers
              .set('Authorization', token.toString())
              .set('Content-Type', 'application/json'),
          });
          return next.handle(cloned);
        } else {
          this.logger.debug('AuthInterceptor', 'Forwarding request without authentication');
          return next.handle(req);
        }
      }),
      catchError((error) => {
        this.logger.error('AuthInterceptor', `HTTP ${req.method} request failed`, error);
        return throwError(() => error);
      }),
    );
  }
}